/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
export const overflowShadow = ({
  leftCoverWidth,
  rightCoverWidth
}) => {
  const width = "var(--ds-space-100, 8px)";
  const leftCoverWidthResolved = leftCoverWidth || width;
  const rightCoverWidthResolved = rightCoverWidth || width;

  // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
  return css`
/* shadow cover left */
  linear-gradient(
    to right,
    ${"var(--ds-background-neutral, #091E420F)"} ${leftCoverWidthResolved},
    transparent ${leftCoverWidthResolved}
  ),
/* shadow cover background left */
  linear-gradient(
    to right,
    ${"var(--ds-surface-raised, #FFFFFF)"} ${leftCoverWidthResolved},
    transparent ${leftCoverWidthResolved}
  ),
/* shadow cover right */
  linear-gradient(
    to left,
    ${"var(--ds-background-neutral, #091E420F)"} ${rightCoverWidthResolved},
    transparent ${rightCoverWidthResolved}
  ),
/* shadow cover background right */
  linear-gradient(
    to left,
    ${"var(--ds-surface-raised, #FFFFFF)"} ${rightCoverWidthResolved},
    transparent ${rightCoverWidthResolved}
  ),
/* overflow shadow right spread */
  linear-gradient(
    to left,
    ${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
    ${"var(--ds-UNSAFE-transparent, transparent)"}  ${width}
  ),
  /* overflow shadow right perimeter */
  linear-gradient(
    to left,
    ${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
    ${"var(--ds-UNSAFE-transparent, transparent)"}  ${width}
  ),
  /* overflow shadow left spread */
  linear-gradient(
    to right,
    ${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
    ${"var(--ds-UNSAFE-transparent, transparent)"}  ${width}
  ),
  /* overflow shadow left perimeter */
  linear-gradient(
    to right,
    ${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
    ${"var(--ds-UNSAFE-transparent, transparent)"}  ${width}
  )
`;
};